  <div class="container-fluid bgcolor2 pdf-viewer-container">
  <div class="row col-sm-12 p-0 m-0 body">
    

    <div class="col-sm-12 toolbar" *ngIf="!noDataaa && (ispdf || isImage)">
      <div class="action-buttons-container">
        <div class="action-buttons">
        <button class="btn btn-secondary" (click)="rotate()" title="Rotate Clockwise">
          ↻ Rotate
        </button>
        <button class="btn btn-secondary" (click)="zoomIn()" title="Zoom In">
          + Zoom
        </button>
        <button class="btn btn-secondary" (click)="zoomOut()" title="Zoom Out">
          - Zoom
        </button>
        <button class="btn btn-secondary" (click)="resetView()" title="Reset View">
          ⟲ Reset
        </button>
        
    
        <div class="page-navigation" *ngIf="totalPages > 0">
          <button class="btn btn-sm btn-outline-primary me-1" (click)="previousPage()" [disabled]="page === 1">
            ‹
          </button>
          <span class="page-info">Page {{page}} of {{totalPages}}</span>
          <button class="btn btn-sm btn-outline-primary ms-1" (click)="nextPage()" [disabled]="page === totalPages">
            ›
          </button>
        </div>
        </div>
      </div>
    </div>


    <div class="col-sm-12 content-main" [class.has-toolbar]="!noDataaa && (ispdf || isImage)">
      
   
      <div *ngIf="isImage" class="image-viewer">
        <img [src]="src" 
        [style.transform]="'rotate(' + rotation + 'deg) scale(' + zoom + ')'"
             class="full-image"
             style="transition: transform 0.3s ease;">
      </div>


      <div *ngIf="ispdf" class="pdf-viewer-wrapper">
        <div class="pdf-rotation-container" [style.transform]="'rotate(' + rotation + 'deg)'">
          <pdf-viewer 
            [src]="src" 
            [original-size]="true"
            [show-all]="true"
            [fit-to-page]="false" 
            [zoom]="zoom" 
            [stick-to-page]="false" 
            [render-text]="true"
            [page]="page"
            (after-load-complete)="onPdfLoad($event)"
            class="full-pdf-viewer">
          </pdf-viewer>
        </div>
      </div>


      <div *ngIf="noDataaa" class="no-data">
        <img src="../../assets/images/emp.png" class="no-data-img">
      </div>
    </div>
    
   <div class="action-buttons-container">
  <div class="action-buttons">
    <button (click)="close()" class="btn btn-secondary">
  Close
</button>

    <button (click)="dowload()" *ngIf="showBtn" class="btn btn-secondary">
      Download
    </button>
  </div>
</div>
